export const PROMO_CODE_ERROR_MESSAGE = 'Invalid promo code';
